export default "__VITE_ASSET__49DLowkf__"